import React, {Fragment} from 'react';
import AboutMain from "./components/main/index";
import TopNav from "../../layouts/navs/auth-topevictions";
import BannerEvictions from "../banners/evictionhome";

const AboutPage = () => {
    return (
        <Fragment>
            <TopNav/>
            <BannerEvictions/>
            <AboutMain/>
        </Fragment>
    );
};

export default AboutPage;
